import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button, Progress } from "antd";
import { IStepsButtonsProps } from "./IFormComponents";

const StepsButtons = (props: IStepsButtonsProps) => {
  const {
    advanceStep,
    goBackStep,
    disableNext,
    disableLast,
    currentStep,
    steps,
	nextText,
	translations
  } = props;

  const percentage = Math.round((currentStep / steps) * 100);

  return (
    <div className="investor-step-buttons">
      <Button
        type="default"
        icon={<ArrowLeftOutlined />}
        disabled={disableLast}
        onClick={goBackStep ? () => goBackStep() : undefined}
        style={{ width: "180px" }}
      >
        {translations.back}
      </Button>
      <div className="investor-step-buttons-progress">
        <p>
          {currentStep} {translations.outOf} {steps}
        </p>
        <Progress
          percent={percentage}
          status="active"
          showInfo={false}
          strokeColor="#B3D615"
        />
      </div>
      <Button
        type="primary"
        disabled={disableNext}
        onClick={advanceStep ? () => advanceStep() : undefined}
        icon={<ArrowRightOutlined />}
        style={{ width: "180px" }}
      >
        {nextText}
      </Button>
    </div>
  );
};

export default StepsButtons;
